import { lazyWithRetry as lazy } from '@utils/lazyWithRetry';
import { RouteConfig } from '@routes/types';

const HomeWrapper = lazy(() => import('@page/HomeWrapper'));
const PageWrapper = lazy(() => import('@page/PageWrapper'));
const PageNotFound = lazy(() => import('@component/PageNotFound/PageNotFound'));
const IconsWrapper = lazy(() => import('@page/IconsWrapper'));
const SomethingWentWrong = lazy(
  () => import('@component/SomethingWentWrong/SomethingWentWrong')
);
const NoAuthorization = lazy(
  () => import('@component/NoAuthorization/NoAuthorization')
);
const PayerInfoLight = lazy(
  () => import('@component/LightVersion/Payer/PayerInfoLight/PayerInfoLight')
);
const PayerFeatures = lazy(
  () => import('@component/LightVersion/Payer/PayerFeatures/PayerFeatures')
);
const PayerServices = lazy(
  () => import('@component/LightVersion/Payer/PayerServices/PayerServicesLight')
);
const PayerSettings = lazy(
  () => import('@component/LightVersion/Payer/PayerSettings/PayerSettings')
);
const Users = lazy(() => import('@component/Users/Users'));
const Permissions = lazy(() => import('@component/Permissions/Permissions'));
const MyRoomAuditLogs = lazy(
  () => import('@component/AuditLog/MyRoomAuditLogs/MyRoomAuditLogs')
);
const ConfigWrapper = lazy(() => import('@page/ConfigWrapper'));

export const payerPortalRoutes: RouteConfig[] = [
  {
    path: '/',
    element: HomeWrapper,
    children: [
      {
        path: 'payors',
        element: PageWrapper,
        children: [
          { path: 'information/:id', element: PayerInfoLight },
          { path: 'features/:id', element: PayerFeatures },
          { path: 'services/:id', element: PayerServices },
          { path: 'settings/:id', element: PayerSettings },
          { path: 'audit-logs/:id', element: MyRoomAuditLogs },
        ],
      },
      {
        path: 'administrator',
        element: PageWrapper,
        children: [
          { path: 'users', element: Users },
          { path: 'permissions', element: Permissions },
        ],
      },
    ],
  },
  {
    path: 'icons',
    element: IconsWrapper,
  },
  {
    path: 'configs',
    element: ConfigWrapper,
  },
  {
    path: 'wrong',
    element: SomethingWentWrong,
  },
  {
    path: 'no-authorization',
    element: NoAuthorization,
  },
  {
    path: '*',
    element: PageNotFound,
  },
];
